// extracted by mini-css-extract-plugin
export var errormessage = "FormTextInput-module--errormessage--84c47";
export var formtextinput = "FormTextInput-module--formtextinput--a1a0e";
export var formtextinputwithlefticon = "FormTextInput-module--formtextinputwithlefticon--17366";
export var iconleft = "FormTextInput-module--iconleft--21cc8";
export var iconright = "FormTextInput-module--iconright--e5552";
export var inputwithicon = "FormTextInput-module--inputwithicon--78d6d";
export var textinputlabel = "FormTextInput-module--textinputlabel--6b5b0";
export var textinputwrapper = "FormTextInput-module--textinputwrapper--d4de1";